import { NgModule, ModuleWithProviders } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IcosBadge } from './badge'


@NgModule({
  declarations: [IcosBadge],
  exports: [IcosBadge],
  imports: [CommonModule],
  entryComponents: [IcosBadge],
})
export class IcosBadgesModule {
  static forRoot(): ModuleWithProviders {
    return { ngModule: IcosBadgesModule, providers: [] }
  }
}
